import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import * as apiGetAllIdentityProviders from 'api/identityProvider/GetIndetityProviderGetAllV1';
import LoginForm from 'components/desktop/User/Login/LoginForm';
import LogoAnimation from 'components/desktop/_general/LogoAnimation/LogoAnimation';
import 'containers/desktop/User/Login/Login.scss';
import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { getTokensFromLocalStorage } from 'functions/tokenFunctions';
import { setTokensToLocalStorage } from 'functions/tokenFunctions';
import ITokens from 'interfaces/ITokens';
import { defaultLoginDto } from 'types/User/Login/LoginDto';

const Login = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [loginDto, setLoginDto] = useState(defaultLoginDto);
	const [extLogoVisible, setExtLogoVisible] = useState<boolean>(true);
	const extLogoPath = '/img/logoExt/external_logo_login.png';
	const [identityProviders, setIdentityProviders] = useState<
		apiGetAllIdentityProviders.IdentityProvider[]
	>([]);
	const navigate = useNavigate();

	useEffect((): void => {
		const tokens = getTokensFromLocalStorage();
		tokens.do((_) => {
			navigateToUrl();
		});

		retrieveIdentityProviders();
	}, []);

	const retrieveIdentityProviders = async () => {
		const response = await apiGetAllIdentityProviders.callApi();
		response.do((x) => setIdentityProviders(x.identityProviders));
	};

	const navigateToUrl = (): void => {
		const pathname: string | null = localStorage.getItem('pathname');
		localStorage.removeItem('pathname');
		navigate(pathname ?? '/dashboard');
	};

	const handleLogin = async () => {
		setIsLoading(true);
		const url = `${SERVICEBASEURL.USER}/User/Login`;
		try {
			const response = await axios.post(url, loginDto);
			const tokens: ITokens = response.data;
			setTokensToLocalStorage(tokens);
			if (response.status == 200) {
				navigateToUrl();
			}
			if (response.status == 422) {
				navigate(`/resendConfirmation?user=${loginDto.email}`);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoading(false);
		}
	};

	const setExtLogoInvisible = (): void => {
		setExtLogoVisible(false);
	};

	const renderContent = () => {
		return (
			<>
				<div className="login-container">
					<h2>Artificial Intelligence Recipes</h2>
					<div className="login-inner-container">
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
							}}
						>
							<div style={{ transform: 'scale(0.8)', transformOrigin: 'center' }}>
								<LogoAnimation />
							</div>
							{extLogoVisible && (
								<>
									<hr
										style={{
											height: '1px',
											width: '100%',
											backgroundColor: 'gray',
											border: 'none',
										}}
									/>
									<img
										src={extLogoPath}
										onError={setExtLogoInvisible}
										style={{
											maxHeight: '80px',
											maxWidth: '220px',
										}}
										className="d-inline-block align-text-middle"
									/>
								</>
							)}
						</div>
						<div className="login-inner-container-div">
							<LoginForm
								loginDto={loginDto}
								identityProviders={identityProviders}
								setLoginDto={setLoginDto}
								handleLogin={handleLogin}
								isLoading={isLoading}
							/>
						</div>
					</div>
				</div>
			</>
		);
	};

	return <>{renderContent()}</>;
};

export default Login;
